import React from 'react';
import { Link } from 'react-router-dom';

function AuthFooter() {
  return (
    <footer className="auth-footer">
      <div className="auth-footer-left">
        <Link to="/terms" className="auth-footer-link">Terms & Conditions</Link>
        <span className="auth-footer-separator">|</span>
        <Link to="/privacy" className="auth-footer-link">Privacy</Link>
        <span className="auth-footer-separator">|</span>
        <Link to="/release-notes" className="auth-footer-link">Release Notes</Link>
      </div>
      <div className="auth-footer-right">
        © 2026 All rights reserved. Begin the Work, LLC
      </div>
    </footer>
  );
}

export default AuthFooter;

